import { BaseModel } from "@blue-chip/core";
import ProjectReport from "./ProjectReport";

export default class ProjectReportDataOption extends BaseModel {
  static get belongsTo() {
    return [ProjectReport];
  }
}
